export default {
  user: {},
  users: [],
}
